import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Swiper } from 'swiper';
import { StorageService } from '../../shared/storage.service';
import { CommonService } from '../../shared/common.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { FooterService } from '../../components/footer/footer.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import confetti from 'canvas-confetti';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

const countryData = require('../country-code.json');

declare var $: any;

@Component({
    selector: 'app-home',
    templateUrl: './kumbh.component.html',
    styleUrls: ['./kumbh.component.css']
})
export class KumbhComponent implements OnInit, AfterViewInit {
    customInqForm: FormGroup;
    customInqSubmitted = false;
    mostVisitedDataList: any = [];
    mostPopulerDataList: any = [];
    trendingDataList: any = [];
    PlaceList: any = [];
    noOfPersonError: string;
    allPackagesDataList: any = [];
    beforeTrackMemberData: any = [];
    countries: any[] = [];
    minDate: string;
    minStartDate: any;
    minEndDate: any;
    endDateBeforeStartDate: boolean = true;
    isMenuCollapsed: boolean = true;
    daysLeft: number = 0;
    errorMessage: string = '';
    countryData = countryData;
    showOtherTextbox = false; // Controls the visibility of the textbox
    otherService = ''; // Holds the value of the textbox
    showPlayer = true;
    datePickerConfig: Partial<BsDatepickerConfig>;
    countdown: string = '';
    intervalId: any;



    constructor(private router: Router,
        public storageService: StorageService,
        public commonService: CommonService,
        public userLayoutService: UserLayoutService,
        private fb: FormBuilder,
        private http: HttpClient,
        private footerService: FooterService) { }

    ngOnInit(): void {
        this.datePickerConfig = {
            containerClass: 'theme-dark-blue',
            dateInputFormat: 'MMM DD, YYYY',
            showWeekNumbers:false,
        };
        this.defaultAddCustomInqForm();
        this.initializePageAnimation();
        this.footerService.showFooter();
        if (localStorage.getItem('bookingDetails')) {
            localStorage.removeItem('bookingDetails');
        }
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Add 1 because getMonth() returns 0-11
        const day = String(today.getDate()).padStart(2, '0');
        this.minDate = `${year}-${month}-${day}`;
        this.allPackagesDataList = [];
        this.mostVisitedDataList = [];
        this.mostPopulerDataList = [];
        this.beforeTrackMemberData = [];
        // this.getMostPopulerPlacesList();
        this.getMostVisitedPlacesList();
        this.getPackagesDataList();
        // this.getTrandingPackageList();
        this.getPlaceListData();
        this.minStartDate = today;
        this.minEndDate = this.minStartDate;
        // this.fetchCountries();
        this.updateCountdown();
        this.intervalId = setInterval(() => this.updateCountdown(), 1000); // Update every second


    }


    ngAfterViewInit(): void {
        // Initialize the Slick carousel
        setTimeout(() => {
            $('.slider-nav').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                centerMode: true,
                focusOnSelect: true,
                autoplay: false, // Disable autoplay
                responsive: [
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }, 0.5);
    }

    initializePageAnimation(): void {
        // Trigger the rose petal animation after the page loads
        setTimeout(() => {
            this.triggerRosePetalRain();
        }, 500); // Delay of 500ms for better UX
    }

    triggerRosePetalRain(): void {
        const duration = 5 * 1000; // 15 seconds
        const end = Date.now() + duration;

        const colors = ['#FF0000', '#FF6347', '#FFC0CB', '#FF69B4']; // Rose-like colors

        const frame = () => {
            confetti({
                particleCount: 5, // Fewer particles for a delicate effect
                startVelocity: 10, // Slow falling effect
                angle: 90, // Directly downwards
                spread: 90, // Wide spread
                colors: colors, // Rose petal colors
                shapes: ['circle'], // Simulating petals with circles
                scalar: 1.2, // Slightly larger particles
                origin: {
                    x: Math.random(), // Random horizontal position
                    y: Math.random() * -0.2, // Start slightly above the viewport
                },
            });

            if (Date.now() < end) {
                requestAnimationFrame(frame); // Loop the animation
            }
        };

        frame();
    }


    defaultAddCustomInqForm(): void {
        this.customInqForm = this.fb.group({
            email: ['', [Validators.required, this.customEmailValidator()]],
            phoneNumber: ['', [Validators.required, Validators.pattern(/^\d{8,12}$/)]],
            countryCode: ['+1', [Validators.required]],
            startDate: ['', Validators.required],
            endDate: ['', Validators.required],
            adults: [1, Validators.required],
            children: [0, Validators.required],
            child: [0, Validators.required],
            startCity: [null, Validators.required],
            endCity: [null, Validators.required],
            placeName: ['', Validators.required],
            isSameAsWhatsApp: [false],
            hotel: [false],
            car: [false],
            activities: [false],
            contactPerson: ['', Validators.required],
            comments: [''],
            otherService: [''],
            childAges: this.fb.array([])
        });

        this.customInqSubmitted = false;
        this.noOfPersonError = '';
    }

    customEmailValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const isValidEmail = emailPattern.test(control.value);
            return isValidEmail ? null : { 'invalidEmail': true };
        };
    }

    searchByName(term: string, item: any): boolean {
        term = term.toLowerCase();
        return item.name.toLowerCase().includes(term) || item.dialCode.toLowerCase().includes(term);
    }

    mobilenumberInput(event: any): void {
        const input = event.target;

        input.value = input.value.replace(/[^0-9]/g, '');

        this.customInqForm.patchValue({
            phoneNumber: input.value || null,
        });
    }

    increaseCount(category: string): void {
        const currentValue = this.customInqForm.get(category)?.value || 0;
        this.customInqForm.get(category)?.setValue(currentValue + 1);
    }

    decreaseCount(category: string): void {
        const currentValue = this.customInqForm.get(category)?.value || 0;
        if (currentValue > 0) {
            this.customInqForm.get(category)?.setValue(currentValue - 1);
        }
    }

    trimWhitespace(event: any): void {
        const input = event.target;
        input.value = input.value.trim();
    }

    goToNext(): void {
        // Manually go to the next slide
        $('.slider-nav').slick('slickNext');
    }

    goToPrev(): void {
        // Manually go to the previous slide
        $('.slider-nav').slick('slickPrev');
    }

    addCustomPlace = (term) => ({ id: term, names: term });

    getMostPopulerPlacesList() {
        this.userLayoutService.getMostPopolarPlacesData().subscribe((Response: any) => {

            if (Response.code == 1) {
                this.mostPopulerDataList = Response.data;
                // console.log("most populer places", this.mostPopulerDataList);
                setTimeout(() => {
                    const swiper = new Swiper('.swiper', {
                        // Optional parameters
                        observer: true,
                        observeParents: true,
                        loop: true,

                        // If we need pagination
                        pagination: {
                            el: '.swiper-pagination',
                        },

                        // Navigation arrows
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },

                        // And if we need scrollbar
                        scrollbar: {
                            el: '.swiper-scrollbar',
                        },
                    });
                }, 0.5);
            }
            else {
                this.router.navigate(['home']);
            }
        }, (error) => {
            // console.log(error.error.Message);
            this.router.navigate(['home']);
        });
    }
    getTrandingPackageList() {
        this.userLayoutService.getTrandingPackageData().subscribe((Response: any) => {
            if (Response.code == 1) {
                this.trendingDataList = Response.data
                    .map((entry: any) => entry.packages)  // Get the 'packages' array
                    .flat()  // Flatten the array so all packages are in one list
                    .filter((packageData: any) => packageData.packageId === 'e4b36615-7e33-4d84-8c96-98e49365a2c9'); // Filter by the specific packageId

                // console.log("Filtered Trending Package places", this.trendingDataList);
            } else {
                this.router.navigate(['home']);
            }
        }, (error) => {
            this.router.navigate(['home']);
        });
    }



    getMostVisitedPlacesList() {
        this.userLayoutService.getMostVisitedPlacesData().subscribe((Response: any) => {

            if (Response.code == 1) {
                this.mostVisitedDataList = Response.data;
                // console.log("most visited places", this.mostVisitedDataList);
            }
            else {
                this.router.navigate(['kumbh']);
            }
        }, (error) => {
            // console.log(error.error.Message);
            this.router.navigate(['kumbh']);
        });
    }

    getPackagesDataList() {
        this.userLayoutService.getHomeScreenPackageData().subscribe((Response: any) => {
            if (Response.code == 1) {
                const allowedPackageIds = [
                    "e4b36615-7e33-4d84-8c96-98e49365a2c9",
                    "ac1490c5-d91c-452b-982d-c998e5f0d22f"
                ];

                this.allPackagesDataList = Response.data
                    .map((entry: any) => entry.packages)
                    .flat()
                    .filter((packageData: any) => allowedPackageIds.includes(packageData.packageId)); // Filter by multiple packageIds

                // console.log("Filtered Packages", this.allPackagesDataList);
            } else {
                this.router.navigate(['kumbh']);
            }
        }, (error) => {
            // console.log(error.error.Message);
            this.router.navigate(['kumbh']);
        });
    }



    getPlaceListData() {
        this.userLayoutService.getPlaceList().subscribe((Response: any) => {
            if (Response.code == 1) {
                // Case-insensitive filter for Prayagraj, Varanasi, Lucknow, Delhi, and Ayodhya
                this.PlaceList = Response.data.filter((city: any) =>
                    ['varanasi', 'lucknow', 'delhi', 'ayodhya', 'prayagraj'].includes(city.names.toLowerCase())
                );
            } else {
                console.warn("Failed to retrieve category details");
            }
        }, (error) => {
            console.error("Error fetching category details:", error.error.Message);
        });
    }

    getStars(feedbackRating: number): number[] {
        const totalStars = 5;
        return Array.from({ length: totalStars }, (_, index) => index < feedbackRating ? 1 : 0);
    }

    onImageError(event: any) {
        event.target.src = 'assets/images/safenet_logo_new.png';
    }

    getPackagesDetailsByCategoryId(id: any, name: any) {
        this.router.navigate(['packages'], {
            queryParams: { categoryId: id, title: name }
        });
    }

    packageDetails(packageId: any) {
        this.router.navigate(['packages-details'], {
            queryParams: { PackageId: packageId }
        });
    }

    get personError() {
        let adults = parseInt(this.customInqForm.value.adults);
        let children = parseInt(this.customInqForm.value.children);

        if ((adults + children) == 0) {
            this.noOfPersonError = "Atleast 1 traveler required.";
            return true
        } else if (children > 0 && adults == 0) {
            this.noOfPersonError = "Atleast 1 Adult required."
            return true
        } else {
            this.noOfPersonError = ""
            return false
        }
    }

    convertToISOFormat(dateString: string): string {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            throw new Error("Invalid date string provided.");
        }

        return date.toISOString();
    }
    AddCustomInquiry() {

        this.customInqSubmitted = true;

        // Validation for form and other fields
        const childAgesArray = this.customInqForm.get('childAges') as FormArray;
        if (this.customInqForm.invalid || this.personError || childAgesArray.invalid) {
            childAgesArray.controls.forEach((control) => control.markAsTouched());
            return;
        }

        const selectedPlaceIds = this.customInqForm.value.placeName; 
        const placeIdToSend = selectedPlaceIds.map((place: any) => ({ placeId: place }));
        const childAges = childAgesArray.value.map((age: any) => ({ age }));

        // Constructing the payload
        const payload = {
            email: this.customInqForm.value.email,
            phoneNumber: this.customInqForm.value.phoneNumber,
            startDate: this.convertToISOFormat(this.customInqForm.value.startDate),
            endDate: this.convertToISOFormat(this.customInqForm.value.endDate),
            adults: this.customInqForm.value.adults,
            children: this.customInqForm.value.children,
            toddler: this.customInqForm.value.child,
            startCity: this.customInqForm.value.startCity,
            endCity: this.customInqForm.value.endCity,
            kumbhPackageInquiryDetailsPlaceId: placeIdToSend,
            isSameAsWhatsApp: this.customInqForm.value.isSameAsWhatsApp,
            hotel: this.customInqForm.value.hotel,
            car: this.customInqForm.value.car,
            activities: this.customInqForm.value.activities,
            contactPerson: this.customInqForm.value.contactPerson,
            comments: this.customInqForm.value.comments,
            countryCode: this.customInqForm.value.countryCode,
            otherService: this.customInqForm.value.otherService,
            childrenAgeDetails: this.customInqForm.value.childAges,
        };

        // Send the inquiry request
        this.userLayoutService.trendingFestivalInquiry(payload).subscribe(
            (Response: any) => {

                if (Response.code === 1) {
                    this.commonService.notifier.notify('success', "We have received your request. MyYatra360 team will reach out to you at the earliest.");
                    this.defaultAddCustomInqForm();

                    this.customInqSubmitted = false;
                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            },
            (error) => {
                this.commonService.notifier.notify('error', error);
            }
        );
    }

    validateCountryCode(event: any): void {
        const input = event.target;
        if (!/^(\+?\d*)$/.test(input.value)) {
            input.value = input.value.replace(/[^0-9+]/g, '');
        }
    }

    onStartDateChange(date: any) {
        this.customInqForm.get('startDate')?.setValue(date);
        const startDate = this.customInqForm.get('startDate')?.value;
        if (startDate) {
            this.minEndDate = startDate;
            this.endDateBeforeStartDate = true;
        } else {
            this.endDateBeforeStartDate = false;
            this.customInqForm.get('endDate')?.setValue(null);
        }
    }

    onEndDateChange(date: any) {
        this.customInqForm.get('endDate')?.setValue(date);
        const startDate = this.customInqForm.get('startDate')?.value;
        const endDate = this.customInqForm.get('endDate')?.value;

        if (startDate) {
            this.endDateBeforeStartDate = true;
        } else {
            this.endDateBeforeStartDate = false;
            this.customInqForm.get('endDate')?.setValue(null);
        }
    }

    fetchCountries() {

        // Fetch country data from the API or static file
        this.http.get<any[]>('https://restcountries.com/v3.1/all').subscribe(
            (data) => {

                // Map API data to required format
                this.countries = data.map((country) => {
                    return {
                        name: country.name.common,
                        dialCode: `${country.idd?.root}${country.idd?.suffixes ? country.idd.suffixes[0] : ''}`,
                        flag: country.flags.png,
                    };
                });
            },
            (error) => {
                console.error('Error fetching country data', error);
                this.errorMessage = "Unable to fetch country codes. Please try again later.";
            }
        );
    }

    searchByName1(term: string, item: any): boolean {
        term = term.toLowerCase();
        return item.name.toLowerCase().includes(term) || item.dial_code.toLowerCase().includes(term) || item.code.toLowerCase().includes(term);
    }

    get childAges() {
        return (this.customInqForm.get('childAges') as FormArray);
    }

    // increaseCountchild(type: string): void {
    //     if (type === 'children') {
    //         const currentChildren = this.customInqForm.get('children')?.value || 0;
    //         this.customInqForm.get('children')?.setValue(currentChildren + 1);

    //         // Add a new FormControl to the childAges FormArray
    //         (this.customInqForm.get('childAges') as FormArray).push(this.fb.control('', [Validators.required, Validators.min(1), Validators.max(11)]));
    //     }
    // }

    // decreaseCountchild(type: string): void {
    //     if (type === 'children') {
    //         const currentChildren = this.customInqForm.get('children')?.value || 0;
    //         if (currentChildren > 0) {
    //             this.customInqForm.get('children')?.setValue(currentChildren - 1);

    //             // Remove the last FormControl from the childAges FormArray
    //             const childAgesArray = this.customInqForm.get('childAges') as FormArray;
    //             childAgesArray.removeAt(childAgesArray.length - 1);
    //         }
    //     }
    // }

    increaseCountchild(type: string, isToddler: boolean): void {
        if (type === 'children' || type === 'child') {
            const currentChildren = this.customInqForm.get('children')?.value || 0;
            const currentToddlers = this.customInqForm.get('child')?.value || 0;
            let childControl;
            // Increase the appropriate counter
            if (isToddler) {
                this.customInqForm.get('child')?.setValue(currentToddlers + 1);
                childControl = this.fb.group({
                    age: ['', [Validators.required, Validators.min(0), Validators.max(4)]],
                    isToddler: [isToddler]
                });
            } else {
                this.customInqForm.get('children')?.setValue(currentChildren + 1);
                childControl = this.fb.group({
                    age: ['', [Validators.required, Validators.min(5), Validators.max(11)]],
                    isToddler: [isToddler]
                });
            }

            (this.customInqForm.get('childAges') as FormArray).push(childControl);
        }
        // console.log(this.customInqForm.value);
    }

    decreaseCountchild(type: string, isToddler: boolean): void {
        if (type === 'children' || type === 'child') {
            const currentChildren = this.customInqForm.get('children')?.value || 0;
            const currentToddlers = this.customInqForm.get('child')?.value || 0;

            // Decrease the appropriate counter
            if (isToddler && currentToddlers > 0) {
                this.customInqForm.get('child')?.setValue(currentToddlers - 1);
            } else if (!isToddler && currentChildren > 0) {
                this.customInqForm.get('children')?.setValue(currentChildren - 1);
            }

            // Remove the last control from childAges FormArray based on isToddler
            const childAgesArray = this.customInqForm.get('childAges') as FormArray;

            // Loop through the array to find and remove the correct control based on 'isToddler'
            for (let i = childAgesArray.length - 1; i >= 0; i--) {
                const control = childAgesArray.at(i);
                if (control.get('isToddler')?.value === isToddler) {
                    childAgesArray.removeAt(i);
                    break;  // Exit the loop once the matching control is removed
                }
            }
        }
    }

    getChildrenControls() {
        return (this.customInqForm.get('childAges') as FormArray).controls.filter(control => !control.get('isToddler')?.value);
    }

    getToddlersControls() {
        return (this.customInqForm.get('childAges') as FormArray).controls.filter(control => control.get('isToddler')?.value);
    }

    addChildAgeControl(): void {
        const control = this.fb.control('', [Validators.required, Validators.min(0), Validators.max(18)]);
        this.childAges.push(control);
    }

    removeChildAgeControl(): void {
        this.childAges.removeAt(this.childAges.length - 1);
    }

    toggleOther(event: Event): void {
        const checkbox = event.target as HTMLInputElement;
        this.showOtherTextbox = checkbox.checked;
        if (!checkbox.checked) {
            this.otherService = ''; // Clear the textbox when unchecked
        }
    }

    calculateDaysLeft(): void {
        const lastDate = new Date('2025-02-26'); // Target date
        const currentDate = new Date(); // Today's date
        const timeDiff = lastDate.getTime() - currentDate.getTime(); // Time difference in milliseconds

        this.daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
    }

    //updateCountdown(): void {
    //    const lastDate = new Date('2025-02-26T00:00:00'); // Target date
    //    const currentDate = new Date(); // Current date
    //    const timeDiff = lastDate.getTime() - currentDate.getTime(); // Time difference in milliseconds

    //    if (timeDiff > 0) {
    //        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24)); // Days left
    //        const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // Hours left
    //        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)); // Minutes left
    //        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000); // Seconds left

    //        this.countdown = `${days} Days ${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds} left`;
    //    } else {
    //        this.countdown = 'Event has ended';
    //    }
    //}

    updateCountdown(): void {
        const lastDate = new Date('2025-02-26T00:00:00'); // Target date
        const currentDate = new Date(); // Current date
        const timeDiff = lastDate.getTime() - currentDate.getTime(); // Time difference in milliseconds

        if (timeDiff > 0) {
            const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24)); // Days left
            const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // Hours left
            const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)); // Minutes left
            const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000); // Seconds left

            // Format with leading zeros for single digits
            const formattedHours = hours < 10 ? `0${hours}` : hours;
            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
            const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

            this.countdown = `${days} Days ${formattedHours}:${formattedMinutes}:${formattedSeconds} left`;
        } else {
            this.countdown = 'Event has ended';
        }
    }

}
